// https://sponda-kohteet.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/html/code/show/pnjOzOybQpOZ37sAy21_IA

// Difference between contacts and contact templates:
// contacts is not editable and takes persons from building database
// contact is editable, contact persons can be changed per brochure page. it still defaults to building db contact person.

import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import UsersContext from 'contexts/Users';
import { colorClassNames } from 'lib/settings';

const pictograms = {
	logo: require(`!raw-loader!../../../../assets/${'logo-black'}.svg`),
	building: require(`!raw-loader!../../../../assets/pictograms/${'icon-kiinteistot'}.svg`),
	location: require(`!raw-loader!../../../../assets/pictograms/${'icon-kartta'}.svg`),
	environment: require(`!raw-loader!../../../../assets/pictograms/${'icon-ymparistopalvelut'}.svg`),
	services: require(`!raw-loader!../../../../assets/pictograms/${'icon-aulapalvelu'}.svg`),
	social: require(`!raw-loader!../../../../assets/pictograms/${'icon-sosiaalitilat'}.svg`),
};

const Contact = props => {
	const {
		t,
		lng,
		options,
		building,
		componentData: data,
		unsavedChanges,
	} = props;

	const backgroundColor = options['background-color'];
	const bgColorClass = backgroundColor in colorClassNames ? colorClassNames[backgroundColor] : '';

	let componentClass = 'b-component b-contacts';

	if (bgColorClass) {
		componentClass += ' b-slot-theme-' + bgColorClass;
	}

	const style = {
		backgroundColor,
	};

	let contacts = [];

	if(unsavedChanges.contact) {
		contacts = unsavedChanges.contact;
	} else if(data.contact) {
		contacts = data.contact;
	} else if(building && Array.isArray(building.mappedContacts) && building.mappedContacts.length) {
		contacts = building.mappedContacts.map(user => user.username);
	}

	// Fix for older data in db
	if(typeof contacts === 'string') {
		contacts = [contacts];
	}

	// Max two contact persons
	contacts = contacts.slice(0, 2);

	return (
		<UsersContext.Consumer>
			{users => (
				<div className={componentClass} style={style}>
					<div className="b-contacts-contacts">
						<h1>{t('contacts/Your contact')}</h1>
						<div className="b-contacts-contacts-container">

							{users.filter(user => contacts.includes(user.username)).map(contact => {
								const imageStyle = {};

								let title = '';

								if (contact.image && 'conversions' in contact.image) {
									imageStyle.backgroundImage = `url(${props.lowres ? contact.image.conversions.min : contact.image.conversions.medium})`;
								}

								if ('i18n' in contact && lng in contact.i18n) {
									title = contact.i18n[lng].title;
								}

								return (
									<div key={contact.id} className="b-contacts-contact">
										<div className="b-contact-image" style={imageStyle}></div>
										<div className="b-contact-details">
											<h4>{contact.firstName} {contact.lastName}</h4>
											<p>{title}</p>
											<p>{contact.phone}</p>
											<p>{contact.email}</p>
										</div>
									</div>
								)
							})}

						</div>

						<div className="b-contacts-sponda">
							<div className="b-contacts-sponda-logo" dangerouslySetInnerHTML={{__html: pictograms.logo }}></div>
							<div className="b-contacts-customer-service">{t('contacts/Your contacts/Customer service')}</div>
							<div className="b-contacts-body">{t('contacts/Your contacts/body')}</div>
						</div>
					</div>

					<div className="b-contacts-why-sponda">
						<h1>{t('contacts/Why sponda')}</h1>

						<div className="b-contact-why-sponda-reason">
							<div className="b-contact-why-sponda-reason-pictogram" dangerouslySetInnerHTML={{__html: pictograms.building }}></div>

							<p>
								<span className="b-reason-title">{t('contacts/Why sponda/1/title')}</span> {t('contacts/Why sponda/1/body')}
							</p>
						</div>

						<div className="b-contact-why-sponda-reason">
							<div className="b-contact-why-sponda-reason-pictogram" dangerouslySetInnerHTML={{__html: pictograms.location }}></div>

							<p>
								<span className="b-reason-title">{t('contacts/Why sponda/2/title')}</span> {t('contacts/Why sponda/2/body')}
							</p>
						</div>

						<div className="b-contact-why-sponda-reason">
							<div className="b-contact-why-sponda-reason-pictogram" dangerouslySetInnerHTML={{__html: pictograms.environment }}></div>

							<p>
								<span className="b-reason-title">{t('contacts/Why sponda/3/title')}</span> {t('contacts/Why sponda/3/body')}
							</p>
						</div>

						<div className="b-contact-why-sponda-reason">
							<div className="b-contact-why-sponda-reason-pictogram" dangerouslySetInnerHTML={{__html: pictograms.services }}></div>

							<p>
								<span className="b-reason-title">{t('contacts/Why sponda/4/title')}</span> {t('contacts/Why sponda/4/body')}
							</p>
						</div>

						<div className="b-contact-why-sponda-reason">
							<div className="b-contact-why-sponda-reason-pictogram" dangerouslySetInnerHTML={{__html: pictograms.social }}></div>

							<p>
								<span className="b-reason-title">{t('contacts/Why sponda/5/title')}</span> {t('contacts/Why sponda/5/body')}
							</p>
						</div>

					</div>
				</div>
			)}
		</UsersContext.Consumer>
	);
}

Contact.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.oneOf(['fi', 'en']),
	options: PropTypes.object,
	unsavedChanges: PropTypes.object,
	building: PropTypes.object,
	slotActive: PropTypes.bool,
	lowres: PropTypes.bool,
}

export default translate('translations')(Contact);
